export enum ImageSize {
  MaxSize = 2048,
}
